import { $$VueBus } from "@/common/global/vueBus";

export default defineNuxtPlugin((nuxtApp) => {
  // 新 API 提供
  nuxtApp.provide("bus", $$VueBus);

  const globals = nuxtApp.vueApp.config.globalProperties;

  // 如果已存在 $bus，则直接跳过，不重复定义
  const desc = Object.getOwnPropertyDescriptor(globals, "$bus");
  if (!desc) {
    Object.defineProperty(globals, "$bus", {
      get() {
        return $$VueBus;
      },
      configurable: true,
      enumerable: true,
    });
  }
});
